import { push } from 'connected-react-router';

import { createProposal, updateProposal } from 'common/api/v1/proposals';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    SAVE_PROPOSAL,
    SAVE_PROPOSAL_SUCCESS,
    SAVE_PROPOSAL_FAILURE,
} from '../actionTypes';
import { createProposalModalActions } from '../reducer';

import openModal from './openModal';

export default (values) => (dispatch) => {
    dispatch(createProposalModalActions[SAVE_PROPOSAL]());
    const isBomExpress = values.type === 'express';

    const newValues = {
        is_bom_express: isBomExpress,
        name: values.name,
        panel: values.panel,
        project: values.project,
    };
    const nextUrl = isBomExpress ? `bom-express` : `panel-layout`;

    const save = values.id
        ? () => updateProposal(newValues, values.id)
        : () => createProposal(newValues);

    save()
        .then((response) => {
            dispatch(
                createProposalModalActions[SAVE_PROPOSAL_SUCCESS](
                    response.data,
                ),
            );
            dispatch(openModal(false));
            showToast();
            dispatch(push(`/${nextUrl}/${response?.data?.designer?.id}`));
        })
        .catch((error) => {
            dispatch(
                createProposalModalActions[SAVE_PROPOSAL_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
